<!-- 编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" width="70%" :append-to-body="true" :before-close="handleCloseDialog">
        <el-form :model="deviceForm" size="mini" label-width="120px">
            <el-tabs v-model="deviceForm.type" type="card" @tab-click="handleClick">
                <el-tab-pane label="控制参数" name="control">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="集控器">
                                <el-select v-model="deviceForm.collector_id" filterable placeholder="请选择集控器" @change="changeCollector">
                                    <el-option
                                        v-for="item in collectorList"
                                        :key="item.oid"
                                        :label="item.dev_name +' : ' + item.dev_serial"
                                        :value="item.oid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="PLC">
                                <el-select v-model="deviceForm.plc_id" filterable placeholder="请选择"  @change="changePlc">
                                    <el-option
                                        v-for="item in plcList"
                                        :key="item.oid"
                                        :label="item.customized_serial + ' : ' + item.device_model"
                                        :value="item.oid">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item
                        v-for="(domain, index) in deviceForm.controlList"
                        :label="'参数' + (index+1)"
                        :key="domain.key"
                    >
                        <el-row :gutter="10">
                            <el-col :span="10">
                                <el-select v-model="domain.oid" filterable placeholder="请选择">
                                    <el-option
                                        v-for="item in varData"
                                        :key="item.value"
                                        :label="item.var_name+' : '+item.var_Initial_addr"
                                        :value="item.oid">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="5">
                                <el-input v-model="domain.value" placeholder="值"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="danger" @click.prevent="removeDomain(domain, 'controlList')">删除</el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addCondition('controlList')">增加控制</el-button>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="跳转场景" name="skipScene">
                    <el-form-item>
                        <el-select v-model="deviceForm.scene_id"  placeholder="请选择场景">
                            <el-option
                                v-for="item in scenes_list"
                                :key="item.oid"
                                :label="item.serverroom_map_name"
                                :value="item.oid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
const Params = {
    type: 'control',
    controlList: [],
    scene_id: '',
    collector_id: '',
    plc_id: '',
}

export default {
    name: 'cmpButtonDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {},
        }
    },
    data () {
        return {
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),
            scenes_list: [],
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },

    computed: {
        ...mapGetters(["machine"]),
        title() {
            return '设置参数';
        },
        collectorList() {
            return this.machine.collect
        },
        plcList() {
            return this.machine.devices
        },
        varData() {
            return this.machine.var_config
        }
    },
    
    methods: {
        async getData() {
            let res = await Service.getServerroombypid();
            if(res) {
                this.scenes_list = res;
            }
        },
       
        // 获取表计
        async getDeviceList(collectId) {
            let params = Object.assign({}, { page_num: 1, page_sum: 1000, }, {OID: collectId});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                // if(list.length>0) {
                    this.deviceForm.plc_id = '';
                    this.$store.dispatch('setDevices', list);
                // }
            }
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            if(terminal_id === '') 
            {
                let list = []
                this.$store.dispatch('setVarConfig', list);
                return
            }
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);

                this.deviceForm.controlList = []
            }
        },
        changeCollector(val) {
            this.getDeviceList(val)
        },
        changePlc(val) {
            this.getPlcConfig(val);
        },
        handleClick(val) {
            this.getData()
        },
        async handleInitData(Val) {
            
            if(JSON.stringify(Val) === "{}") return;
            if(Val.dataset.params !== undefined) {
                // 编辑
                let params = JSON.parse(Val.dataset.params);
                if(params.type === 'control') {
                    await this.getDeviceList(params.collector_id);
                    await this.getPlcConfig(params.plc_id);
                }else{
                    await this.getData()
                }
                this.deviceForm = params
            }else{
                // 新增
                this.deviceForm = JSON.parse(JSON.stringify(Params));
            }
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认关闭
        handleSave() {
            this.$emit("handleCloseDialog", {flag: true, data: this.deviceForm});
			//window.location.reload()
        },
        
        addCondition(type) {
            this.deviceForm[type].push({
                oid: '',
                value: '',
                key: Date.now()
            });
        },
        removeDomain(item, type) {
            var index = this.deviceForm[type].indexOf(item)
            if (index !== -1) {
                this.deviceForm[type].splice(index, 1)
            }
        },
    }
}

</script>
<style lang='less' scoped>

</style>